// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131714/js/" + chunkId + "." + {"44":"7a2a0295","225":"bd9ba7f6","481":"d600a260","486":"42bfb9b7","770":"2708b10e"}[chunkId] + ".0.76598746258582.chunk.js";
};